import React, { Component } from 'react'
import styled from 'styled-components'
import theme from 'ui/styles/theme'
import easing from 'ui/styles/easing'

const TransitionPath = styled.path`
  transition: fill 0.3s ${easing.easeOutCubic};
`

export default class IconClimate extends Component {
  render() {
    const { hover, active } = this.props
    
    return (
      <svg
        width="55"
        height="54"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <path
            id="a"
            d="M0 50.5h51.872V0H0z"
          />
        </defs>
        <g
          fill="none"
          fillRule="evenodd"
        >
          <TransitionPath
            fill={hover || active ? theme.colors.primary : theme.colors.secondary}
            d="M23.504 14.562c-1.597 0-2.897 1.327-2.897 2.957V31.21l-.284.155c-2.208 1.204-3.58 3.538-3.58 6.09 0 3.804 3.033 6.9 6.761 6.9 3.729 0 6.762-3.096 6.762-6.9 0-2.552-1.372-4.886-3.58-6.09l-.284-.155V17.52c0-1.631-1.3-2.958-2.898-2.958m0 30.888c-4.32 0-7.834-3.587-7.834-7.996 0-2.846 1.472-5.457 3.863-6.893V17.52c0-2.234 1.782-4.052 3.971-4.052 2.19 0 3.971 1.818 3.971 4.052v13.042c2.392 1.436 3.864 4.047 3.864 6.893 0 4.41-3.515 7.996-7.835 7.996"
          />
          <TransitionPath
            fill={hover || active ? theme.colors.primary : theme.colors.secondary}
            d="M22.694 31.422h1.08V17.394h-1.08zM22.964 34.185c-1.662 0-3.014 1.403-3.014 3.129 0 1.725 1.352 3.13 3.014 3.13 1.662 0 3.014-1.405 3.014-3.13 0-1.726-1.352-3.13-3.014-3.13m0 7.338c-2.234 0-4.052-1.888-4.052-4.208 0-2.32 1.818-4.208 4.052-4.208 2.234 0 4.052 1.887 4.052 4.208 0 2.32-1.818 4.208-4.052 4.208M30.799 23.567h6.484v-1.123h-6.484z"
          />
          <TransitionPath
            fill={hover || active ? theme.colors.primary : theme.colors.secondary}
            d="M33.5 26.372h1.081v-6.733H33.5zM30.799 29.178h6.484v-1.122h-6.484z"
          />
          <TransitionPath
            fill={hover || active ? theme.colors.primary : theme.colors.secondary}
            d="M47.009 23.567h-1.055v25.838H4.837V23.567H3.782V50.5h43.227zM25.836 0L0 22.257l.67.863L25.832 1.444l25.365 22.123.675-.859z"
          />
        </g>
      </svg>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/ProductsNew/IconClimate.js